// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"5b749257","977":"98b7cae5"}[chunkId] + ".chunk.js");